import { gql } from '@apollo/client';

const MARK_TICKET_COMMENT_AS_SEEN = gql`
  mutation markTicketCommentAsSeen($input: MarkTicketCommentAsSeenInput!) {
    markTicketCommentAsSeen(input: $input) {
      isSuccess
      message
    }
  }
`;

export default MARK_TICKET_COMMENT_AS_SEEN;
